const FilterReducer = (state = {}, action) => {
    switch (action.type) {
        case 'ADD_FILTER':
            return { ...state, [action.payload.key]: action.payload.value };
        case 'REMOVE_FILTER': {
            const { [action.payload]: _, ...rest } = state;
            return rest;
        }
        case 'CLEAR_FILTERS':
            return {};
        default:
            return state;
    }
};

export default FilterReducer;
